import React, { useMemo } from "react";

import classNames from "classnames";
import { useRouter } from "next/router";

import { Text } from "components/ui/source";

import Banner from "../../atoms/Banner";

import styles from "./AlertBanner.module.scss";

interface Props {
  heading?: string;
  description?: string | React.ReactNode;
  startTimestamp?: number;
  endTimestamp?: number;
  backgroundColor?: "marigold";
  excludedUrlPatterns?: RegExp[];
}

export function AlertBanner({
  heading,
  description,
  startTimestamp,
  endTimestamp,
  backgroundColor,
  excludedUrlPatterns,
}: Props) {
  const { pathname } = useRouter();

  const isHidden = useMemo(() => {
    const currentTimestamp = Date.now() / 1000;
    return (
      (startTimestamp && currentTimestamp < startTimestamp) ||
      (endTimestamp && currentTimestamp > endTimestamp) ||
      !!excludedUrlPatterns?.some(regex => pathname.match(regex))
    );
  }, [pathname, excludedUrlPatterns, startTimestamp, endTimestamp]);

  return !isHidden && (heading || description) ? (
    <Banner height="auto">
      <div className={classNames(styles.banner, styles[backgroundColor])}>
        {heading && (
          <Text types={["subtitle1", "bolder", "align_center"]}>{heading}</Text>
        )}

        {description && (
          <Text types={["body1", "align_center"]}>{description}</Text>
        )}
      </div>
    </Banner>
  ) : null;
}
